export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

export const getUniqueKey = () => new Date().getTime() + Math.random();

export const enqueueSnackbar = (notification: any) => {
  const key = notification.options && notification.options.key;

  return {
    type: ENQUEUE_SNACKBAR,
    notification: {
      ...notification,
      key: key || getUniqueKey()
    }
  };
};

export const closeSnackbar = (key: any) => ({
  type: CLOSE_SNACKBAR,
  dismissAll: !key,
  key
});

export const removeSnackbar = (key: any) => ({
  type: REMOVE_SNACKBAR,
  key
});

const defaultState = {
  notifications: []
};

const NotificationReducer = (state = defaultState, action: any) => {
  switch (action.type) {
    case ENQUEUE_SNACKBAR:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            key: action.key,
            ...action.notification
          }
        ]
      };

    case CLOSE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.map((notification: any) =>
          action.dismissAll || notification.key === action.key
            ? { ...notification, dismissed: true }
            : { ...notification }
        )
      };

    case REMOVE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification: any) => notification.key !== action.key
        )
      };

    default:
      return state;
  }
};

export default NotificationReducer;
